const defaultPresetColors = [
  '#FFFFFF',
  '#cccccc',
  '#333333',
  '#000000',
  '#ffcccc',
  '#9F0500',
  '#F44E3B',
  '#D33115',
  '#C45100',
  '#E27300',
  '#FE9200',
  '#FB9E00',
  '#FCC400',
  '#FCDC00',
  '#DBDF00',
  '#B0BC00',
  '#808900',
  '#A4DD00',
  '#68BC00',
  '#194D33',
  '#68CCCA',
  '#16A5A5',
  '#0C797D',
  '#c4f0f4',
  '#73D8FF',
  '#009CE0',
  '#0062B1',
  '#AEA1FF',
  '#7B64FF',
  '#653294',
  '#FA28FF',
  '#AB149E',
];

export default defaultPresetColors;
